<div *ngFor="let row of config.elements" class="row">
    <div *ngFor="let e of row" [ngClass]="getSize(e)">
        <app-dynamic-container *ngIf="isIncluded(e)" [config]="e"></app-dynamic-container>
    </div>
</div>